<script lang="ts" setup>
  import { parseInline } from 'marked'

  import { BngPageFooter } from '~/layouts/components'

  const router = useRouter()
  const route = useRoute()
  const { t } = useI18n()
  const { matches: matchDesktop } = useMatchMedia(ScreenWidth.desktop)

  async function displayFaq() {
    await router.push({ query: { ...route.query, modal: 'faq' } })
  }

  useHead({
    title: 'Bookandgolf | Qui sommes-nous',
    meta: [
      {
        name: 'description',
        content:
          'Bookandgolf consacre son énergie et ses compétences à un seul objectif : offrir une expérience de golf unique et simplifiée à nos utilisateurs',
      },
    ],
  })
</script>
<template>
  <div class="p-about">
    <StaticPageHeader
      :illustration="`/illustrations/illus-page-entreprise-${ matchDesktop ? 'desk' : 'mobile'}.png`"
      :title-main="parseInline(t('about.title-main'), {breaks: true, async: false})"
      :title-bottom="parseInline(t('about.title-bottom'), {breaks: true, async: false})"
      :bubble-title="parseInline(t('about.bubble-title'), {breaks: true, async: false})"
      :bubble-text="parseInline(t('about.bubble-text'), {breaks: true, async: false})"
    />
    <AppLinkBlock />
    <div class="cards">
      <StaticPageCard
        icon="goal"
        :title="t('about.card-1-title')"
      >
        <div
          class="text"
          v-html="t('about.card-1-text')"
        />
        <div class="icons-subtitle">
          <div
            v-for="item in [
              ['illustration-annulation', 'about.secure-payment'],
              ['illustration-golf-player', 'about.free-canceling'],
              ['illustration-parcours', 'about.promotions-and-voucher'],
              ['illustration-promotion', 'about.reservations-24-24'],
            ]"
            :key="item[0]"
            class="icon-subtitle"
          >
            <img
              :alt="item[0]"
              class="icon"
              :src="`illustrations/${item[0]}.svg`"
            >
            <div class="subtitle">
              {{ t(item[1]) }}
            </div>
          </div>
        </div>
      </StaticPageCard>
      <StaticPageCard
        icon="network"
        :title="t('about.card-2-title')"
      >
        <div
          class="text"
          v-html="t('about.card-2-text')"
        />
      </StaticPageCard>
    </div>
    <ContactBlock @second-click="displayFaq" />
    <BngPageFooter />
  </div>
</template>
<style scoped>

.p-about {
  background-color: white;

  .values-subtitle {
    display: flex;
    flex-flow: row wrap;
  }

  .c-static-page-card {
    .text {
      margin-top: 1rem;
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 0.875em;
      font-weight: 600;
      line-height: 1.47;
    }

    .icons-subtitle {
      display: flex;
      flex-flow: row wrap;
      margin-top: 1rem;

      .icon-subtitle {
        display: flex;
        width: 50%;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 1rem;

        .icon {
          width: 4rem;
          height: 4rem;
        }

        .subtitle {
          margin: 0 0.5rem;
          color: var(--color-secondary);
          font-family: Open-Sans, sans-serif;
          font-size: 0.875em;
          font-weight: 600;
          line-height: 1.36;
          text-align: center;
        }
      }
    }
  }

  @media screen and (width >= 1024px) {
    .cards {
      display: flex;
      flex-direction: row;
      justify-content: center;

      > .c-static-page-card {
        display: flex;
        max-width: 34rem;
        flex: 1 0 auto;
        margin: 4em;

        .text {
          font-size: 1.125em;
          line-height: 1.56;
        }
      }
    }
  }
}

</style>
